import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { FlexContainer } from '../../../../styled/layout.styled';

const StyledTopBlock = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: ${({ height }) => height};
  padding: 8px 0 16px 0;
  border-radius: 10px;
  background-color: #ffffff;
  position: relative;
  top: 8px;
`;

const StyledCaption = styled.h4`
  text-align: center;
  color: #22096c;
`;

const StyledBottomBlock = styled.div`
  width: 100%;
  height: ${({ height }) => height};
  position: relative;
  border-radius: 10px;
  box-shadow: 0 0 4px 0 rgba(57, 24, 62, 0.4);
  background-image: linear-gradient(to bottom, #ff4c75, #4b0074);
`;

const StyledH3 = styled.h2`
  position: absolute;
  bottom: 8px;
  width: 100%;
  text-align: center;
  color: #ffffff;
`;

const CommissionCard = ({ height, bsv, percentage }) => (
  <>
    <FlexContainer
      width="16%"
      tabletWidth="32%"
      mobileWidth="46%"
      mobilePadding={bsv === 500 || bsv === 5000 ? '32px 0 0 0' : ''}
      flexDirection="column"
      justifyContent="flex-end"
    >
      <StyledTopBlock height="54px">
        <StyledCaption>
          {bsv}
          <span className="large bold"> BSV</span>
        </StyledCaption>
      </StyledTopBlock>
      <StyledBottomBlock height={height}>
        <StyledH3>{percentage}</StyledH3>
      </StyledBottomBlock>
    </FlexContainer>
  </>
);

CommissionCard.propTypes = {
  height: PropTypes.string.isRequired,
  bsv: PropTypes.string.isRequired,
  percentage: PropTypes.string.isRequired,
};

export default CommissionCard;
